// extracted by mini-css-extract-plugin
module.exports = {"iframe":"_ce383da","paper":"_b3d8efd","content":"_06988a7"};